<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.quotations'), $t('text.list')]">
        <el-button
          v-if="Permit.canActionsChargeEdition('quoteToCustomerManage')"
          type="success"
          size="mini"
          @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="items"
        :loading="loading"
        id="itemsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="name" :title="$t('menu.customers')">
          <template v-slot="{ row }">
            <router-link
              :to="{
                name: 'pdmQuotationsShow',
                params: { id: row.id },
                query: { customerName: row.name },
              }"
            >
              {{ row.name }}
              <span v-if="row.tenantName != null">({{ row.tenantName }})</span>
            </router-link>
          </template>
        </vxe-table-column>
        <vxe-table-column field="quantity" :title="$t('quotation.quantity')" />
        <vxe-table-column
          v-if="Permit.canActionsChargeEdition('quoteToCustomerManage')"
          field="action"
          :title="$t('text.action')"
          width="50"
        >
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <el-dialog
      :title="$t('menu.customers')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="30%"
    >
      <el-form ref="addObjForm" :model="addObj" style="padding-bottom: 50px">
        <div class="orange font12 mgb10">
          {{ $t("prompt.quotationAddExplain") }}
        </div>
        <el-form-item
          prop="'customerId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.customers')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="addObj.customerId"
            filterable
            remote
            :placeholder="$t('placeholder.customerNameCompanyPhone')"
            :remote-method="querySearchCustomer"
            :loading="customerLoading"
            @change="handleSelectCustomer"
          >
            <el-option
              v-for="customer in customers"
              :key="customer.id"
              :label="customer.text"
              :value="customer.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Quotation from "@/api/quotation.js";
import Customer from "@/api/customer.js";
export default {
  mixins: [page],
  data() {
    return {
      items: [],
      //
      addDF: false,
      addObj: {
        customerId: null,
      },
      customerLoading: false,
      customers: [],
      addDoing: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    add() {
      this.addDF = true;
    },
    querySearchCustomer(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.customerLoading = true;
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        self.customers = res.data.filter((c) => c.type === "wholesale");
        if (self.customers.length !== 0) {
          for (const c of self.customers) {
            if (c.sourceTenantId == null) {
              Vue.set(c, "text", c.name + "（无简赢协同账号）");
            } else {
              Vue.set(c, "text", c.name);
            }
          }
        }
        self.customerLoading = false;
      });
    },

    handleSelectCustomer() {
      this.$router.push({
        name: "pdmQuotationsNew",
        params: { id: this.addObj.customerId },
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Quotation.deleteByCustomerId(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    loadData() {
      const self = this;
      self.loadingStart();
      Quotation.qtyToQuoter().then(function (res) {
        if (res.status === 200) {
          self.items = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>
